import path from 'path';
import { app, BrowserWindow, Menu, Tray } from "electron";

let tray: Tray;

function createTray(mainWindow: BrowserWindow, defaultIcon: 'ico' | 'icns') {
    const iconPath = path.join(process.cwd(), 'public', `ultima-logo.${defaultIcon}`);
    console.log('Icon Path:', iconPath);

    try {
        tray = new Tray(iconPath);
        console.log('Tray created successfully');

        const contextMenu = Menu.buildFromTemplate([
            {
                label: 'Open',
                click: () => { mainWindow.show(); }
            },
            { type: 'separator' },
            {
                label: 'Quit Ultima',
                click: () => {
                    tray.destroy();
                    app.quit();
                }
            },
        ]);

        tray.setToolTip('Ultima');
        tray.setContextMenu(contextMenu);

        tray.on('double-click', () => {
            mainWindow.show();
        });

    } catch (error) {
        console.error('Failed to create tray icon:', error);
    }
}

export default createTray;